
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'


export default {
components: {
XHeader,
XInput,
Group,
XButton
},
data () {
return {
flag:false,
orderDetail:{},
role:''
}
},
methods:{
confirm(){
var token = localStorage.getItem('token')
var opid = localStorage.getItem('userid')
var that = this
var header = {
headers:{
token:token,
opid:opid
}
}
var obj = {
role:this.role
}
this.$http.post('api/v1/projects/'+this.orderDetail.seq+'/refresh',obj,header)
.then(res => {
that.$router.push({name:'myrecord'})
console.log(res)
})
.catch(error => {
console.log(error.response)
})
}
},
beforeRouteEnter (to, from, next) {
if(from.name == 'myrecord'){
next(vm => {
vm.orderDetail = vm.$route.params.order
console.log( vm.orderDetail)
if(vm.orderDetail.state == '备案超时'){
vm.flag = true
}
var order = JSON.stringify(vm.orderDetail)
localStorage.setItem('order',order)

var token = localStorage.getItem('token')
var opid = localStorage.getItem('userid')
var header = {
headers:{
token:token,
opid:opid
}
}
AjaxPlugin.$http.get('/api/v1/accounts/'+opid,header)
.then(res => {
for (let i=0;i<res.data.length;i++){
if(res.data[i].type == 'INDV'){
vm.role = 'INDV'
}
if(res.data[i].type == 'ENTP'){
vm.role = 'ENTP'
}
if(res.data[i].type == 'EXPT'){
vm.role = 'EXPT'
}
if(res.data[i].type == 'SRVP'){
vm.role = 'SRVP'
}
}
})
})
}
else {
next (vm =>{
var order = localStorage.getItem('order')
vm.orderDetail = JSON.parse(order)

if(vm.orderDetail.state == '备案超时'){
vm.flag = true
}
var token = localStorage.getItem('token')
var opid = localStorage.getItem('userid')
var header = {
headers:{
token:token,
opid:opid
}
}
AjaxPlugin.$http.get('/api/v1/accounts/'+opid,header)
.then(res => {
for (let i=0;i<res.data.length;i++){
if(res.data[i].type == 'INDV'){
vm.role = 'INDV'
}
if(res.data[i].type == 'ENTP'){
vm.role = 'ENTP'
}
if(res.data[i].type == 'EXPT'){
vm.role = 'EXPT'
}
if(res.data[i].type == 'SRVP'){
vm.role = 'SRVP'
}
}
})
})
}

}
}



// WEBPACK FOOTER //
// ./src/components/myrecordcomplete.vue